// Who may reach the BackOffice system-status screen: exactly the BackOffice
// role. Gates both the IAM nav tab and the `/backoffice/system-status` route.
export const canManageSystemStatus = (isBackOffice: boolean): boolean =>
  isBackOffice
